// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as EmployeeRouteRouteImport } from './routes/_employee/route'
import { Route as AanbiedingenRouteImport } from './routes/aanbiedingen'
import { Route as AccessPointsRouteImport } from './routes/access-points'
import { Route as ActievoorwaardenRouteImport } from './routes/actievoorwaarden'
import { Route as AdviesRouteImport } from './routes/advies'
import { Route as AssortimentRouteImport } from './routes/assortiment'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BedanktRouteImport } from './routes/bedankt'
import { Route as BedenktijdRouteImport } from './routes/bedenktijd'
import { Route as BetaalmethodenRouteImport } from './routes/betaalmethoden'
import { Route as BeveiligingstechniekRouteImport } from './routes/beveiligingstechniek'
import { Route as CamConfiguratorRouteImport } from './routes/cam-configurator'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as DekkingRouteImport } from './routes/dekking'
import { Route as DienstenRouteImport } from './routes/diensten'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as ElektrotechniekRouteImport } from './routes/elektrotechniek'
import { Route as ElvionGroupRouteImport } from './routes/elvion-group'
import { Route as EmailPreviewRouteImport } from './routes/email-preview'
import { Route as GarantieRouteImport } from './routes/garantie'
import { Route as GidsLaadpaalKostenRouteImport } from './routes/gids-laadpaal-kosten'
import { Route as GroepenkastConfiguratorRouteImport } from './routes/groepenkast-configurator'
import { Route as GroepenkastKeuzeRouteImport } from './routes/groepenkast-keuze'
import { Route as HdConfiguratorRouteImport } from './routes/hd-configurator'
import { Route as InloggegevensVergetenRouteImport } from './routes/inloggegevens-vergeten'
import { Route as InternetCalculatorRouteImport } from './routes/internet-calculator'
import { Route as KlachtenRouteImport } from './routes/klachten'
import { Route as KlantenserviceRouteImport } from './routes/klantenservice'
import { Route as KlantportaalRouteImport } from './routes/klantportaal'
import { Route as LaadpaalInstallateurRouteImport } from './routes/laadpaal-installateur'
import { Route as LaadpaalInstallerenStappenplanRouteImport } from './routes/laadpaal-installeren-stappenplan'
import { Route as LedCalculatorRouteImport } from './routes/led-calculator'
import { Route as ModelformulierHerroepingRouteImport } from './routes/modelformulier-herroeping'
import { Route as NetwerktechniekRouteImport } from './routes/netwerktechniek'
import { Route as OfferteAanvragenRouteImport } from './routes/offerte-aanvragen'
import { Route as OrderStatusRouteImport } from './routes/order-status'
import { Route as OverOnsRouteImport } from './routes/over-ons'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RetourbeleidRouteImport } from './routes/retourbeleid'
import { Route as UptimeRouteImport } from './routes/uptime'
import { Route as VermogenCalculatorRouteImport } from './routes/vermogen-calculator'
import { Route as VerzendbeleidRouteImport } from './routes/verzendbeleid'
import { Route as VoorwaardenRouteImport } from './routes/voorwaarden'
import { Route as WebshopRouteImport } from './routes/webshop'
import { Route as WordKlantRouteImport } from './routes/word-klant'
import { Route as ZakelijkRouteImport } from './routes/zakelijk'
import { Route as AuthenticatedPrijzenRouteImport } from './routes/_authenticated/prijzen'
import { Route as AuthenticatedSetupAdminRouteImport } from './routes/_authenticated/setup-admin'
import { Route as BetalenOrderIdRouteImport } from './routes/betalen.$orderId'
import { Route as BetalingPaymentIdRouteImport } from './routes/betaling.$paymentId'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CIndexRouteImport } from './routes/c.index'
import { Route as ElectricienOfferteOpvragenRouteImport } from './routes/electricien-offerte.opvragen'
import { Route as GroepenkastVervangenIndexRouteImport } from './routes/groepenkast-vervangen.index'
import { Route as GroepenkastVervangenStadRouteImport } from './routes/groepenkast-vervangen.$stad'
import { Route as InfoSlugRouteImport } from './routes/info.$slug'
import { Route as InfoMeterkastVervangenKostenRouteImport } from './routes/info.meterkast-vervangen-kosten'
import { Route as MedewerkerLoginRouteImport } from './routes/medewerker.login'
import { Route as OfferteIndexRouteImport } from './routes/offerte.index'
import { Route as OfferteCamerabewakingRouteImport } from './routes/offerte.camerabewaking'
import { Route as OfferteGroepenkastenRouteImport } from './routes/offerte.groepenkasten'
import { Route as ProductSlugRouteImport } from './routes/product.$slug'
import { Route as WerkenBijIndexRouteImport } from './routes/werken-bij.index'
import { Route as WerkenBijSlugRouteImport } from './routes/werken-bij.$slug'
import { Route as AuthenticatedAccountIndexRouteImport } from './routes/_authenticated/account/index'
import { Route as AuthenticatedAccountAdressenRouteImport } from './routes/_authenticated/account/adressen'
import { Route as AuthenticatedAccountBestellingenRouteImport } from './routes/_authenticated/account/bestellingen'
import { Route as AuthenticatedAccountBeveiligingRouteImport } from './routes/_authenticated/account/beveiliging'
import { Route as AuthenticatedAccountDocumentenRouteImport } from './routes/_authenticated/account/documenten'
import { Route as AuthenticatedAccountOffertesRouteImport } from './routes/_authenticated/account/offertes'
import { Route as AuthenticatedAccountOpeningstijdenRouteImport } from './routes/_authenticated/account/openingstijden'
import { Route as AuthenticatedAccountProfielRouteImport } from './routes/_authenticated/account/profiel'
import { Route as AuthenticatedAccountZakelijkRouteImport } from './routes/_authenticated/account/zakelijk'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminAlgemeneVoorwaardenRouteImport } from './routes/_authenticated/admin/algemene-voorwaarden'
import { Route as AuthenticatedAdminBlogRouteImport } from './routes/_authenticated/admin/blog'
import { Route as AuthenticatedAdminCityHitsRouteImport } from './routes/_authenticated/admin/city-hits'
import { Route as AuthenticatedAdminEmailHealthRouteImport } from './routes/_authenticated/admin/email-health'
import { Route as AuthenticatedAdminEmailInstellingenRouteImport } from './routes/_authenticated/admin/email-instellingen'
import { Route as AuthenticatedAdminFacturenRouteImport } from './routes/_authenticated/admin/facturen'
import { Route as AuthenticatedAdminFaqsRouteImport } from './routes/_authenticated/admin/faqs'
import { Route as AuthenticatedAdminFeedAuditRouteImport } from './routes/_authenticated/admin/feed-audit'
import { Route as AuthenticatedAdminHikvisionGtinsRouteImport } from './routes/_authenticated/admin/hikvision-gtins'
import { Route as AuthenticatedAdminKanalenRouteImport } from './routes/_authenticated/admin/kanalen'
import { Route as AuthenticatedAdminKlantenRouteImport } from './routes/_authenticated/admin/klanten'
import { Route as AuthenticatedAdminOffertesRouteImport } from './routes/_authenticated/admin/offertes'
import { Route as AuthenticatedAdminOpenstaandAfhalenRouteImport } from './routes/_authenticated/admin/openstaand-afhalen'
import { Route as AuthenticatedAdminOrdersRouteImport } from './routes/_authenticated/admin/orders'
import { Route as AuthenticatedAdminProductenRouteImport } from './routes/_authenticated/admin/producten'
import { Route as AuthenticatedAdminSeoRouteImport } from './routes/_authenticated/admin/seo'
import { Route as AuthenticatedAdminSeoAuditRouteImport } from './routes/_authenticated/admin/seo-audit'
import { Route as AuthenticatedAdminSitemapChecksRouteImport } from './routes/_authenticated/admin/sitemap-checks'
import { Route as AuthenticatedAdminSocialPreviewRouteImport } from './routes/_authenticated/admin/social-preview'
import { Route as AuthenticatedAdminStripeWebhooksRouteImport } from './routes/_authenticated/admin/stripe-webhooks'
import { Route as AuthenticatedAdminWebhookEventsRouteImport } from './routes/_authenticated/admin/webhook-events'
import { Route as AuthenticatedAdminWhatsappRouteImport } from './routes/_authenticated/admin/whatsapp'
import { Route as AuthenticatedAdminWhatsappTemplatesRouteImport } from './routes/_authenticated/admin/whatsapp-templates'
import { Route as AuthenticatedMedewerkerOfficeRouteImport } from './routes/_authenticated/medewerker/office'
import { Route as AuthenticatedMedewerkerVoysInstellingenRouteImport } from './routes/_authenticated/medewerker/voys-instellingen'
import { Route as CCategoryIndexRouteImport } from './routes/c.$category.index'
import { Route as CCategorySubcategoryRouteImport } from './routes/c.$category.$subcategory'
import { Route as AuthenticatedAccountBestellingenIdRouteImport } from './routes/_authenticated/account/bestellingen.$id'
import { Route as AuthenticatedAccountOffertesIndexRouteImport } from './routes/_authenticated/account/offertes.index'
import { Route as AuthenticatedAccountOffertesIdRouteImport } from './routes/_authenticated/account/offertes.$id'
import { Route as EmployeeMedewerkerOfficeIndexRouteImport } from './routes/_employee/medewerker.office.index'
import { Route as EmployeeMedewerkerOfficeAanvragenRouteImport } from './routes/_employee/medewerker.office.aanvragen'
import { Route as EmployeeMedewerkerOfficeDoorgestuurdRouteImport } from './routes/_employee/medewerker.office.doorgestuurd'
import { Route as EmployeeMedewerkerOfficeKlantenRouteImport } from './routes/_employee/medewerker.office.klanten'
import { Route as EmployeeMedewerkerOfficeOrdersRouteImport } from './routes/_employee/medewerker.office.orders'
import { Route as EmployeeMedewerkerOfficePlanningRouteImport } from './routes/_employee/medewerker.office.planning'
import { Route as EmployeeMedewerkerOfficeSeoCheckRouteImport } from './routes/_employee/medewerker.office.seo-check'
import { Route as EmployeeMedewerkerOfficeTelefonieRouteImport } from './routes/_employee/medewerker.office.telefonie'
import { Route as EmployeeMedewerkerOfficeAanvragenIdRouteImport } from './routes/_employee/medewerker.office.aanvragen.$id'
import { Route as EmployeeMedewerkerOfficeKlantenIdRouteImport } from './routes/_employee/medewerker.office.klanten.$id'
import { Route as EmployeeMedewerkerOfficeOffertesIndexRouteImport } from './routes/_employee/medewerker.office.offertes.index'
import { Route as EmployeeMedewerkerOfficeOffertesIdRouteImport } from './routes/_employee/medewerker.office.offertes.$id'
import { Route as EmployeeMedewerkerOfficeOffertesNieuwRouteImport } from './routes/_employee/medewerker.office.offertes.nieuw'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const EmployeeRouteRoute = EmployeeRouteRouteImport.update({
            id: '/_employee',getParentRoute: () => rootRouteImport
          })
const AanbiedingenRoute = AanbiedingenRouteImport.update({
            id: '/aanbiedingen',path: '/aanbiedingen',getParentRoute: () => rootRouteImport
          })
const AccessPointsRoute = AccessPointsRouteImport.update({
            id: '/access-points',path: '/access-points',getParentRoute: () => rootRouteImport
          })
const ActievoorwaardenRoute = ActievoorwaardenRouteImport.update({
            id: '/actievoorwaarden',path: '/actievoorwaarden',getParentRoute: () => rootRouteImport
          })
const AdviesRoute = AdviesRouteImport.update({
            id: '/advies',path: '/advies',getParentRoute: () => rootRouteImport
          })
const AssortimentRoute = AssortimentRouteImport.update({
            id: '/assortiment',path: '/assortiment',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BedanktRoute = BedanktRouteImport.update({
            id: '/bedankt',path: '/bedankt',getParentRoute: () => rootRouteImport
          })
const BedenktijdRoute = BedenktijdRouteImport.update({
            id: '/bedenktijd',path: '/bedenktijd',getParentRoute: () => rootRouteImport
          })
const BetaalmethodenRoute = BetaalmethodenRouteImport.update({
            id: '/betaalmethoden',path: '/betaalmethoden',getParentRoute: () => rootRouteImport
          })
const BeveiligingstechniekRoute = BeveiligingstechniekRouteImport.update({
            id: '/beveiligingstechniek',path: '/beveiligingstechniek',getParentRoute: () => rootRouteImport
          })
const CamConfiguratorRoute = CamConfiguratorRouteImport.update({
            id: '/cam-configurator',path: '/cam-configurator',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const DekkingRoute = DekkingRouteImport.update({
            id: '/dekking',path: '/dekking',getParentRoute: () => rootRouteImport
          })
const DienstenRoute = DienstenRouteImport.update({
            id: '/diensten',path: '/diensten',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const ElektrotechniekRoute = ElektrotechniekRouteImport.update({
            id: '/elektrotechniek',path: '/elektrotechniek',getParentRoute: () => rootRouteImport
          })
const ElvionGroupRoute = ElvionGroupRouteImport.update({
            id: '/elvion-group',path: '/elvion-group',getParentRoute: () => rootRouteImport
          })
const EmailPreviewRoute = EmailPreviewRouteImport.update({
            id: '/email-preview',path: '/email-preview',getParentRoute: () => rootRouteImport
          })
const GarantieRoute = GarantieRouteImport.update({
            id: '/garantie',path: '/garantie',getParentRoute: () => rootRouteImport
          })
const GidsLaadpaalKostenRoute = GidsLaadpaalKostenRouteImport.update({
            id: '/gids-laadpaal-kosten',path: '/gids-laadpaal-kosten',getParentRoute: () => rootRouteImport
          })
const GroepenkastConfiguratorRoute = GroepenkastConfiguratorRouteImport.update({
            id: '/groepenkast-configurator',path: '/groepenkast-configurator',getParentRoute: () => rootRouteImport
          })
const GroepenkastKeuzeRoute = GroepenkastKeuzeRouteImport.update({
            id: '/groepenkast-keuze',path: '/groepenkast-keuze',getParentRoute: () => rootRouteImport
          })
const HdConfiguratorRoute = HdConfiguratorRouteImport.update({
            id: '/hd-configurator',path: '/hd-configurator',getParentRoute: () => rootRouteImport
          })
const InloggegevensVergetenRoute = InloggegevensVergetenRouteImport.update({
            id: '/inloggegevens-vergeten',path: '/inloggegevens-vergeten',getParentRoute: () => rootRouteImport
          })
const InternetCalculatorRoute = InternetCalculatorRouteImport.update({
            id: '/internet-calculator',path: '/internet-calculator',getParentRoute: () => rootRouteImport
          })
const KlachtenRoute = KlachtenRouteImport.update({
            id: '/klachten',path: '/klachten',getParentRoute: () => rootRouteImport
          })
const KlantenserviceRoute = KlantenserviceRouteImport.update({
            id: '/klantenservice',path: '/klantenservice',getParentRoute: () => rootRouteImport
          })
const KlantportaalRoute = KlantportaalRouteImport.update({
            id: '/klantportaal',path: '/klantportaal',getParentRoute: () => rootRouteImport
          })
const LaadpaalInstallateurRoute = LaadpaalInstallateurRouteImport.update({
            id: '/laadpaal-installateur',path: '/laadpaal-installateur',getParentRoute: () => rootRouteImport
          })
const LaadpaalInstallerenStappenplanRoute = LaadpaalInstallerenStappenplanRouteImport.update({
            id: '/laadpaal-installeren-stappenplan',path: '/laadpaal-installeren-stappenplan',getParentRoute: () => rootRouteImport
          })
const LedCalculatorRoute = LedCalculatorRouteImport.update({
            id: '/led-calculator',path: '/led-calculator',getParentRoute: () => rootRouteImport
          })
const ModelformulierHerroepingRoute = ModelformulierHerroepingRouteImport.update({
            id: '/modelformulier-herroeping',path: '/modelformulier-herroeping',getParentRoute: () => rootRouteImport
          })
const NetwerktechniekRoute = NetwerktechniekRouteImport.update({
            id: '/netwerktechniek',path: '/netwerktechniek',getParentRoute: () => rootRouteImport
          })
const OfferteAanvragenRoute = OfferteAanvragenRouteImport.update({
            id: '/offerte-aanvragen',path: '/offerte-aanvragen',getParentRoute: () => rootRouteImport
          })
const OrderStatusRoute = OrderStatusRouteImport.update({
            id: '/order-status',path: '/order-status',getParentRoute: () => rootRouteImport
          })
const OverOnsRoute = OverOnsRouteImport.update({
            id: '/over-ons',path: '/over-ons',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RetourbeleidRoute = RetourbeleidRouteImport.update({
            id: '/retourbeleid',path: '/retourbeleid',getParentRoute: () => rootRouteImport
          })
const UptimeRoute = UptimeRouteImport.update({
            id: '/uptime',path: '/uptime',getParentRoute: () => rootRouteImport
          })
const VermogenCalculatorRoute = VermogenCalculatorRouteImport.update({
            id: '/vermogen-calculator',path: '/vermogen-calculator',getParentRoute: () => rootRouteImport
          })
const VerzendbeleidRoute = VerzendbeleidRouteImport.update({
            id: '/verzendbeleid',path: '/verzendbeleid',getParentRoute: () => rootRouteImport
          })
const VoorwaardenRoute = VoorwaardenRouteImport.update({
            id: '/voorwaarden',path: '/voorwaarden',getParentRoute: () => rootRouteImport
          })
const WebshopRoute = WebshopRouteImport.update({
            id: '/webshop',path: '/webshop',getParentRoute: () => rootRouteImport
          })
const WordKlantRoute = WordKlantRouteImport.update({
            id: '/word-klant',path: '/word-klant',getParentRoute: () => rootRouteImport
          })
const ZakelijkRoute = ZakelijkRouteImport.update({
            id: '/zakelijk',path: '/zakelijk',getParentRoute: () => rootRouteImport
          })
const AuthenticatedPrijzenRoute = AuthenticatedPrijzenRouteImport.update({
            id: '/prijzen',path: '/prijzen',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSetupAdminRoute = AuthenticatedSetupAdminRouteImport.update({
            id: '/setup-admin',path: '/setup-admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const BetalenOrderIdRoute = BetalenOrderIdRouteImport.update({
            id: '/betalen/$orderId',path: '/betalen/$orderId',getParentRoute: () => rootRouteImport
          })
const BetalingPaymentIdRoute = BetalingPaymentIdRouteImport.update({
            id: '/betaling/$paymentId',path: '/betaling/$paymentId',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const CIndexRoute = CIndexRouteImport.update({
            id: '/c/',path: '/c/',getParentRoute: () => rootRouteImport
          })
const ElectricienOfferteOpvragenRoute = ElectricienOfferteOpvragenRouteImport.update({
            id: '/electricien-offerte/opvragen',path: '/electricien-offerte/opvragen',getParentRoute: () => rootRouteImport
          })
const GroepenkastVervangenIndexRoute = GroepenkastVervangenIndexRouteImport.update({
            id: '/groepenkast-vervangen/',path: '/groepenkast-vervangen/',getParentRoute: () => rootRouteImport
          })
const GroepenkastVervangenStadRoute = GroepenkastVervangenStadRouteImport.update({
            id: '/groepenkast-vervangen/$stad',path: '/groepenkast-vervangen/$stad',getParentRoute: () => rootRouteImport
          })
const InfoSlugRoute = InfoSlugRouteImport.update({
            id: '/info/$slug',path: '/info/$slug',getParentRoute: () => rootRouteImport
          })
const InfoMeterkastVervangenKostenRoute = InfoMeterkastVervangenKostenRouteImport.update({
            id: '/info/meterkast-vervangen-kosten',path: '/info/meterkast-vervangen-kosten',getParentRoute: () => rootRouteImport
          })
const MedewerkerLoginRoute = MedewerkerLoginRouteImport.update({
            id: '/medewerker/login',path: '/medewerker/login',getParentRoute: () => rootRouteImport
          })
const OfferteIndexRoute = OfferteIndexRouteImport.update({
            id: '/offerte/',path: '/offerte/',getParentRoute: () => rootRouteImport
          })
const OfferteCamerabewakingRoute = OfferteCamerabewakingRouteImport.update({
            id: '/offerte/camerabewaking',path: '/offerte/camerabewaking',getParentRoute: () => rootRouteImport
          })
const OfferteGroepenkastenRoute = OfferteGroepenkastenRouteImport.update({
            id: '/offerte/groepenkasten',path: '/offerte/groepenkasten',getParentRoute: () => rootRouteImport
          })
const ProductSlugRoute = ProductSlugRouteImport.update({
            id: '/product/$slug',path: '/product/$slug',getParentRoute: () => rootRouteImport
          })
const WerkenBijIndexRoute = WerkenBijIndexRouteImport.update({
            id: '/werken-bij/',path: '/werken-bij/',getParentRoute: () => rootRouteImport
          })
const WerkenBijSlugRoute = WerkenBijSlugRouteImport.update({
            id: '/werken-bij/$slug',path: '/werken-bij/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAccountIndexRoute = AuthenticatedAccountIndexRouteImport.update({
            id: '/account/',path: '/account/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAccountAdressenRoute = AuthenticatedAccountAdressenRouteImport.update({
            id: '/account/adressen',path: '/account/adressen',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAccountBestellingenRoute = AuthenticatedAccountBestellingenRouteImport.update({
            id: '/account/bestellingen',path: '/account/bestellingen',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAccountBeveiligingRoute = AuthenticatedAccountBeveiligingRouteImport.update({
            id: '/account/beveiliging',path: '/account/beveiliging',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAccountDocumentenRoute = AuthenticatedAccountDocumentenRouteImport.update({
            id: '/account/documenten',path: '/account/documenten',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAccountOffertesRoute = AuthenticatedAccountOffertesRouteImport.update({
            id: '/account/offertes',path: '/account/offertes',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAccountOpeningstijdenRoute = AuthenticatedAccountOpeningstijdenRouteImport.update({
            id: '/account/openingstijden',path: '/account/openingstijden',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAccountProfielRoute = AuthenticatedAccountProfielRouteImport.update({
            id: '/account/profiel',path: '/account/profiel',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAccountZakelijkRoute = AuthenticatedAccountZakelijkRouteImport.update({
            id: '/account/zakelijk',path: '/account/zakelijk',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminAlgemeneVoorwaardenRoute = AuthenticatedAdminAlgemeneVoorwaardenRouteImport.update({
            id: '/admin/algemene-voorwaarden',path: '/admin/algemene-voorwaarden',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminBlogRoute = AuthenticatedAdminBlogRouteImport.update({
            id: '/admin/blog',path: '/admin/blog',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminCityHitsRoute = AuthenticatedAdminCityHitsRouteImport.update({
            id: '/admin/city-hits',path: '/admin/city-hits',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminEmailHealthRoute = AuthenticatedAdminEmailHealthRouteImport.update({
            id: '/admin/email-health',path: '/admin/email-health',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminEmailInstellingenRoute = AuthenticatedAdminEmailInstellingenRouteImport.update({
            id: '/admin/email-instellingen',path: '/admin/email-instellingen',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminFacturenRoute = AuthenticatedAdminFacturenRouteImport.update({
            id: '/admin/facturen',path: '/admin/facturen',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminFaqsRoute = AuthenticatedAdminFaqsRouteImport.update({
            id: '/admin/faqs',path: '/admin/faqs',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminFeedAuditRoute = AuthenticatedAdminFeedAuditRouteImport.update({
            id: '/admin/feed-audit',path: '/admin/feed-audit',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminHikvisionGtinsRoute = AuthenticatedAdminHikvisionGtinsRouteImport.update({
            id: '/admin/hikvision-gtins',path: '/admin/hikvision-gtins',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminKanalenRoute = AuthenticatedAdminKanalenRouteImport.update({
            id: '/admin/kanalen',path: '/admin/kanalen',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminKlantenRoute = AuthenticatedAdminKlantenRouteImport.update({
            id: '/admin/klanten',path: '/admin/klanten',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminOffertesRoute = AuthenticatedAdminOffertesRouteImport.update({
            id: '/admin/offertes',path: '/admin/offertes',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminOpenstaandAfhalenRoute = AuthenticatedAdminOpenstaandAfhalenRouteImport.update({
            id: '/admin/openstaand-afhalen',path: '/admin/openstaand-afhalen',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminOrdersRoute = AuthenticatedAdminOrdersRouteImport.update({
            id: '/admin/orders',path: '/admin/orders',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminProductenRoute = AuthenticatedAdminProductenRouteImport.update({
            id: '/admin/producten',path: '/admin/producten',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminSeoRoute = AuthenticatedAdminSeoRouteImport.update({
            id: '/admin/seo',path: '/admin/seo',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminSeoAuditRoute = AuthenticatedAdminSeoAuditRouteImport.update({
            id: '/admin/seo-audit',path: '/admin/seo-audit',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminSitemapChecksRoute = AuthenticatedAdminSitemapChecksRouteImport.update({
            id: '/admin/sitemap-checks',path: '/admin/sitemap-checks',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminSocialPreviewRoute = AuthenticatedAdminSocialPreviewRouteImport.update({
            id: '/admin/social-preview',path: '/admin/social-preview',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminStripeWebhooksRoute = AuthenticatedAdminStripeWebhooksRouteImport.update({
            id: '/admin/stripe-webhooks',path: '/admin/stripe-webhooks',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminWebhookEventsRoute = AuthenticatedAdminWebhookEventsRouteImport.update({
            id: '/admin/webhook-events',path: '/admin/webhook-events',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminWhatsappRoute = AuthenticatedAdminWhatsappRouteImport.update({
            id: '/admin/whatsapp',path: '/admin/whatsapp',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminWhatsappTemplatesRoute = AuthenticatedAdminWhatsappTemplatesRouteImport.update({
            id: '/admin/whatsapp-templates',path: '/admin/whatsapp-templates',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMedewerkerOfficeRoute = AuthenticatedMedewerkerOfficeRouteImport.update({
            id: '/medewerker/office',path: '/medewerker/office',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMedewerkerVoysInstellingenRoute = AuthenticatedMedewerkerVoysInstellingenRouteImport.update({
            id: '/medewerker/voys-instellingen',path: '/medewerker/voys-instellingen',getParentRoute: () => AuthenticatedRouteRoute
          })
const CCategoryIndexRoute = CCategoryIndexRouteImport.update({
            id: '/c/$category/',path: '/c/$category/',getParentRoute: () => rootRouteImport
          })
const CCategorySubcategoryRoute = CCategorySubcategoryRouteImport.update({
            id: '/c/$category/$subcategory',path: '/c/$category/$subcategory',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAccountBestellingenIdRoute = AuthenticatedAccountBestellingenIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAccountBestellingenRoute
          })
const AuthenticatedAccountOffertesIndexRoute = AuthenticatedAccountOffertesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAccountOffertesRoute
          })
const AuthenticatedAccountOffertesIdRoute = AuthenticatedAccountOffertesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAccountOffertesRoute
          })
const EmployeeMedewerkerOfficeIndexRoute = EmployeeMedewerkerOfficeIndexRouteImport.update({
            id: '/medewerker/office/',path: '/medewerker/office/',getParentRoute: () => EmployeeRouteRoute
          })
const EmployeeMedewerkerOfficeAanvragenRoute = EmployeeMedewerkerOfficeAanvragenRouteImport.update({
            id: '/medewerker/office/aanvragen',path: '/medewerker/office/aanvragen',getParentRoute: () => EmployeeRouteRoute
          })
const EmployeeMedewerkerOfficeDoorgestuurdRoute = EmployeeMedewerkerOfficeDoorgestuurdRouteImport.update({
            id: '/medewerker/office/doorgestuurd',path: '/medewerker/office/doorgestuurd',getParentRoute: () => EmployeeRouteRoute
          })
const EmployeeMedewerkerOfficeKlantenRoute = EmployeeMedewerkerOfficeKlantenRouteImport.update({
            id: '/medewerker/office/klanten',path: '/medewerker/office/klanten',getParentRoute: () => EmployeeRouteRoute
          })
const EmployeeMedewerkerOfficeOrdersRoute = EmployeeMedewerkerOfficeOrdersRouteImport.update({
            id: '/medewerker/office/orders',path: '/medewerker/office/orders',getParentRoute: () => EmployeeRouteRoute
          })
const EmployeeMedewerkerOfficePlanningRoute = EmployeeMedewerkerOfficePlanningRouteImport.update({
            id: '/medewerker/office/planning',path: '/medewerker/office/planning',getParentRoute: () => EmployeeRouteRoute
          })
const EmployeeMedewerkerOfficeSeoCheckRoute = EmployeeMedewerkerOfficeSeoCheckRouteImport.update({
            id: '/medewerker/office/seo-check',path: '/medewerker/office/seo-check',getParentRoute: () => EmployeeRouteRoute
          })
const EmployeeMedewerkerOfficeTelefonieRoute = EmployeeMedewerkerOfficeTelefonieRouteImport.update({
            id: '/medewerker/office/telefonie',path: '/medewerker/office/telefonie',getParentRoute: () => EmployeeRouteRoute
          })
const EmployeeMedewerkerOfficeAanvragenIdRoute = EmployeeMedewerkerOfficeAanvragenIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => EmployeeMedewerkerOfficeAanvragenRoute
          })
const EmployeeMedewerkerOfficeKlantenIdRoute = EmployeeMedewerkerOfficeKlantenIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => EmployeeMedewerkerOfficeKlantenRoute
          })
const EmployeeMedewerkerOfficeOffertesIndexRoute = EmployeeMedewerkerOfficeOffertesIndexRouteImport.update({
            id: '/medewerker/office/offertes/',path: '/medewerker/office/offertes/',getParentRoute: () => EmployeeRouteRoute
          })
const EmployeeMedewerkerOfficeOffertesIdRoute = EmployeeMedewerkerOfficeOffertesIdRouteImport.update({
            id: '/medewerker/office/offertes/$id',path: '/medewerker/office/offertes/$id',getParentRoute: () => EmployeeRouteRoute
          })
const EmployeeMedewerkerOfficeOffertesNieuwRoute = EmployeeMedewerkerOfficeOffertesNieuwRouteImport.update({
            id: '/medewerker/office/offertes/nieuw',path: '/medewerker/office/offertes/nieuw',getParentRoute: () => EmployeeRouteRoute
          })





const AuthenticatedAccountBestellingenRouteChildren = {
  AuthenticatedAccountBestellingenIdRoute: AuthenticatedAccountBestellingenIdRoute
}

const AuthenticatedAccountBestellingenRouteWithChildren = AuthenticatedAccountBestellingenRoute._addFileChildren(AuthenticatedAccountBestellingenRouteChildren)




const AuthenticatedAccountOffertesRouteChildren = {
  AuthenticatedAccountOffertesIdRoute: AuthenticatedAccountOffertesIdRoute,AuthenticatedAccountOffertesIndexRoute: AuthenticatedAccountOffertesIndexRoute
}

const AuthenticatedAccountOffertesRouteWithChildren = AuthenticatedAccountOffertesRoute._addFileChildren(AuthenticatedAccountOffertesRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedPrijzenRoute: AuthenticatedPrijzenRoute,AuthenticatedSetupAdminRoute: AuthenticatedSetupAdminRoute,AuthenticatedAccountAdressenRoute: AuthenticatedAccountAdressenRoute,AuthenticatedAccountBestellingenRoute: AuthenticatedAccountBestellingenRouteWithChildren,AuthenticatedAccountBeveiligingRoute: AuthenticatedAccountBeveiligingRoute,AuthenticatedAccountDocumentenRoute: AuthenticatedAccountDocumentenRoute,AuthenticatedAccountOffertesRoute: AuthenticatedAccountOffertesRouteWithChildren,AuthenticatedAccountOpeningstijdenRoute: AuthenticatedAccountOpeningstijdenRoute,AuthenticatedAccountProfielRoute: AuthenticatedAccountProfielRoute,AuthenticatedAccountZakelijkRoute: AuthenticatedAccountZakelijkRoute,AuthenticatedAdminAlgemeneVoorwaardenRoute: AuthenticatedAdminAlgemeneVoorwaardenRoute,AuthenticatedAdminBlogRoute: AuthenticatedAdminBlogRoute,AuthenticatedAdminCityHitsRoute: AuthenticatedAdminCityHitsRoute,AuthenticatedAdminEmailHealthRoute: AuthenticatedAdminEmailHealthRoute,AuthenticatedAdminEmailInstellingenRoute: AuthenticatedAdminEmailInstellingenRoute,AuthenticatedAdminFacturenRoute: AuthenticatedAdminFacturenRoute,AuthenticatedAdminFaqsRoute: AuthenticatedAdminFaqsRoute,AuthenticatedAdminFeedAuditRoute: AuthenticatedAdminFeedAuditRoute,AuthenticatedAdminHikvisionGtinsRoute: AuthenticatedAdminHikvisionGtinsRoute,AuthenticatedAdminKanalenRoute: AuthenticatedAdminKanalenRoute,AuthenticatedAdminKlantenRoute: AuthenticatedAdminKlantenRoute,AuthenticatedAdminOffertesRoute: AuthenticatedAdminOffertesRoute,AuthenticatedAdminOpenstaandAfhalenRoute: AuthenticatedAdminOpenstaandAfhalenRoute,AuthenticatedAdminOrdersRoute: AuthenticatedAdminOrdersRoute,AuthenticatedAdminProductenRoute: AuthenticatedAdminProductenRoute,AuthenticatedAdminSeoRoute: AuthenticatedAdminSeoRoute,AuthenticatedAdminSeoAuditRoute: AuthenticatedAdminSeoAuditRoute,AuthenticatedAdminSitemapChecksRoute: AuthenticatedAdminSitemapChecksRoute,AuthenticatedAdminSocialPreviewRoute: AuthenticatedAdminSocialPreviewRoute,AuthenticatedAdminStripeWebhooksRoute: AuthenticatedAdminStripeWebhooksRoute,AuthenticatedAdminWebhookEventsRoute: AuthenticatedAdminWebhookEventsRoute,AuthenticatedAdminWhatsappRoute: AuthenticatedAdminWhatsappRoute,AuthenticatedAdminWhatsappTemplatesRoute: AuthenticatedAdminWhatsappTemplatesRoute,AuthenticatedMedewerkerOfficeRoute: AuthenticatedMedewerkerOfficeRoute,AuthenticatedMedewerkerVoysInstellingenRoute: AuthenticatedMedewerkerVoysInstellingenRoute,AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const EmployeeMedewerkerOfficeAanvragenRouteChildren = {
  EmployeeMedewerkerOfficeAanvragenIdRoute: EmployeeMedewerkerOfficeAanvragenIdRoute
}

const EmployeeMedewerkerOfficeAanvragenRouteWithChildren = EmployeeMedewerkerOfficeAanvragenRoute._addFileChildren(EmployeeMedewerkerOfficeAanvragenRouteChildren)




const EmployeeMedewerkerOfficeKlantenRouteChildren = {
  EmployeeMedewerkerOfficeKlantenIdRoute: EmployeeMedewerkerOfficeKlantenIdRoute
}

const EmployeeMedewerkerOfficeKlantenRouteWithChildren = EmployeeMedewerkerOfficeKlantenRoute._addFileChildren(EmployeeMedewerkerOfficeKlantenRouteChildren)



const EmployeeRouteRouteChildren = {
  EmployeeMedewerkerOfficeAanvragenRoute: EmployeeMedewerkerOfficeAanvragenRouteWithChildren,EmployeeMedewerkerOfficeDoorgestuurdRoute: EmployeeMedewerkerOfficeDoorgestuurdRoute,EmployeeMedewerkerOfficeKlantenRoute: EmployeeMedewerkerOfficeKlantenRouteWithChildren,EmployeeMedewerkerOfficeOrdersRoute: EmployeeMedewerkerOfficeOrdersRoute,EmployeeMedewerkerOfficePlanningRoute: EmployeeMedewerkerOfficePlanningRoute,EmployeeMedewerkerOfficeSeoCheckRoute: EmployeeMedewerkerOfficeSeoCheckRoute,EmployeeMedewerkerOfficeTelefonieRoute: EmployeeMedewerkerOfficeTelefonieRoute,EmployeeMedewerkerOfficeIndexRoute: EmployeeMedewerkerOfficeIndexRoute,EmployeeMedewerkerOfficeOffertesIdRoute: EmployeeMedewerkerOfficeOffertesIdRoute,EmployeeMedewerkerOfficeOffertesNieuwRoute: EmployeeMedewerkerOfficeOffertesNieuwRoute,EmployeeMedewerkerOfficeOffertesIndexRoute: EmployeeMedewerkerOfficeOffertesIndexRoute
}

const EmployeeRouteRouteWithChildren = EmployeeRouteRoute._addFileChildren(EmployeeRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,EmployeeRouteRoute: EmployeeRouteRouteWithChildren,AanbiedingenRoute: AanbiedingenRoute,AccessPointsRoute: AccessPointsRoute,ActievoorwaardenRoute: ActievoorwaardenRoute,AdviesRoute: AdviesRoute,AssortimentRoute: AssortimentRoute,AuthRoute: AuthRoute,BedanktRoute: BedanktRoute,BedenktijdRoute: BedenktijdRoute,BetaalmethodenRoute: BetaalmethodenRoute,BeveiligingstechniekRoute: BeveiligingstechniekRoute,CamConfiguratorRoute: CamConfiguratorRoute,CheckoutRoute: CheckoutRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,DekkingRoute: DekkingRoute,DienstenRoute: DienstenRoute,DisclaimerRoute: DisclaimerRoute,ElektrotechniekRoute: ElektrotechniekRoute,ElvionGroupRoute: ElvionGroupRoute,EmailPreviewRoute: EmailPreviewRoute,GarantieRoute: GarantieRoute,GidsLaadpaalKostenRoute: GidsLaadpaalKostenRoute,GroepenkastConfiguratorRoute: GroepenkastConfiguratorRoute,GroepenkastKeuzeRoute: GroepenkastKeuzeRoute,HdConfiguratorRoute: HdConfiguratorRoute,InloggegevensVergetenRoute: InloggegevensVergetenRoute,InternetCalculatorRoute: InternetCalculatorRoute,KlachtenRoute: KlachtenRoute,KlantenserviceRoute: KlantenserviceRoute,KlantportaalRoute: KlantportaalRoute,LaadpaalInstallateurRoute: LaadpaalInstallateurRoute,LaadpaalInstallerenStappenplanRoute: LaadpaalInstallerenStappenplanRoute,LedCalculatorRoute: LedCalculatorRoute,ModelformulierHerroepingRoute: ModelformulierHerroepingRoute,NetwerktechniekRoute: NetwerktechniekRoute,OfferteAanvragenRoute: OfferteAanvragenRoute,OrderStatusRoute: OrderStatusRoute,OverOnsRoute: OverOnsRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,RetourbeleidRoute: RetourbeleidRoute,UptimeRoute: UptimeRoute,VermogenCalculatorRoute: VermogenCalculatorRoute,VerzendbeleidRoute: VerzendbeleidRoute,VoorwaardenRoute: VoorwaardenRoute,WebshopRoute: WebshopRoute,WordKlantRoute: WordKlantRoute,ZakelijkRoute: ZakelijkRoute,BetalenOrderIdRoute: BetalenOrderIdRoute,BetalingPaymentIdRoute: BetalingPaymentIdRoute,BlogSlugRoute: BlogSlugRoute,ElectricienOfferteOpvragenRoute: ElectricienOfferteOpvragenRoute,GroepenkastVervangenStadRoute: GroepenkastVervangenStadRoute,InfoSlugRoute: InfoSlugRoute,InfoMeterkastVervangenKostenRoute: InfoMeterkastVervangenKostenRoute,MedewerkerLoginRoute: MedewerkerLoginRoute,OfferteCamerabewakingRoute: OfferteCamerabewakingRoute,OfferteGroepenkastenRoute: OfferteGroepenkastenRoute,ProductSlugRoute: ProductSlugRoute,WerkenBijSlugRoute: WerkenBijSlugRoute,BlogIndexRoute: BlogIndexRoute,CIndexRoute: CIndexRoute,GroepenkastVervangenIndexRoute: GroepenkastVervangenIndexRoute,OfferteIndexRoute: OfferteIndexRoute,WerkenBijIndexRoute: WerkenBijIndexRoute,CCategorySubcategoryRoute: CCategorySubcategoryRoute,CCategoryIndexRoute: CCategoryIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)